import PropTypes from "prop-types";
import { CgClose } from "react-icons/cg";
import "../../../styles/ModalLayout.css";
function ModalLayout({
  children = null,
  setShowModal = () => {},
  modalTitle = "",
}) {
  return (
    <div className="flex justify-center items-center fixed inset-0 z-50 outline-none border-none focus:outline-none bg-black/40  backdrop-blur-sm">
      <div className="relative w-auto my-6 ">
        <div className="border-0  shadow-lg relative flex flex-col lg:w-[60vw] w-[90vw] max-h-[500px] overflow-y-auto bg-white border-none outline-none focus:outline-none">
          <div className="bg-gray-200 dark:bg-blue-gray-800  border-none">
            <div className="relative flex  items-center justify-evenly bg-blue-gray-700 ">
              <img className="w-32 mb-3" src="/pxLogo.png" alt="" />
              <h1 className="text-center text-warning-50  dark:text-red-600 border-2 border-deep-orange-200 text-[18px] font-[600] uppercase border-none px-5 rounded-md">
                {" "}
                {modalTitle}
              </h1>
              <button
                type="button"
                className="absolute right-2  bg-white rounded-full text-black  dark:text-darkTextPrimary p-2 border-none"
                onClick={() => setShowModal(false)}
              >
                <CgClose size={22} color="red" />
              </button>
            </div>
          </div>
          <div className="relative p-8 flex-auto dark:bg-blue-gray-800 border-none  overflow-x-hidden overflow-y-auto">
            {children}
          </div>
        </div>
      </div>
    </div>
  );
}

ModalLayout.propTypes = {
  children: PropTypes.node,
  setShowModal: PropTypes.func.isRequired,
  modalTitle: PropTypes.string,
};

ModalLayout.defaultProps = {
  children: null,
  modalTitle: "",
};

export default ModalLayout;
